import type { FunctionComponent } from 'react';
import React from 'react';

/**
 * Car Icon - Used in shopfor page
 */
export const CarIcon: FunctionComponent<{ size?: number; color?: string }> = (props) => {
  const { size = 22, color = '#0D202F' } = props;

  return (
    <svg width={size} height={(14 / 22) * size} viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 5.66666H16.6667" stroke={color} strokeMiterlimit="10" />
      <path
        d="M19.3333 11H21.3333V5.66667H16.6667L14 1H6.00001L4.00001 5.66667H1.33334V11H3.33334"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path d="M7.33334 11H15.3333" stroke={color} strokeMiterlimit="10" strokeLinecap="square" />
      <path
        d="M5.33337 13C6.43794 13 7.33337 12.1046 7.33337 11C7.33337 9.89543 6.43794 9 5.33337 9C4.2288 9 3.33337 9.89543 3.33337 11C3.33337 12.1046 4.2288 13 5.33337 13Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M17.3334 13C18.4379 13 19.3334 12.1046 19.3334 11C19.3334 9.89543 18.4379 9 17.3334 9C16.2288 9 15.3334 9.89543 15.3334 11C15.3334 12.1046 16.2288 13 17.3334 13Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path d="M10 1V5.66667" stroke={color} strokeMiterlimit="10" />
    </svg>
  );
};
